import type {ComponentProps, ReactNode} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

type Props = ComponentProps<'span'> & {
	children?: ReactNode;
	className?: string;
};

export const Tag = ({children, className, ...rest}: Props) => {
	return (
		<span
			className={cn(
				'inline-block rounded-sm bg-black/70 px-2 py-1 text-center text-neutral-200 lg:px-2.5 lg:py-1.5',
				className,
			)}
			{...rest}
		>
			{children}
		</span>
	);
};
